export interface INavigationState {
	isSidebarExpanded: boolean;
  isAdminMode: boolean;
}

export const initialNavigationState: INavigationState = {
	isSidebarExpanded: true,
  isAdminMode: true,
};
